module.exports = __webpack_public_path__ + "assets/img/list-5.1e771794.png";